import React from "react";
import { classNames } from "../../helpers/classNames";

const Switch = ({ checked, onChange = () => { }, className = "", name }) => {
  return (
    <>
      <div className="relative overflow-hidden flex items-center">
        <input
          name={name}
          type="checkbox"
          className="peer absolute top-0 left-0 z-10 opacity-0 cursor-pointer w-full h-full"
          checked={checked}
          onChange={onChange}
        />
        <div
          className={classNames(
            "w-12 h-6 rounded-3xl border border-md-pink-light-1 bg-md-pink-light-2 transition-all duration-200",
            "before:absolute before:content-[''] before:top-1/2 before:left-0.5 before:-translate-y-1/2 before:bg-white before:w-5 before:h-5 before:rounded-full before:transition-all duration-200 before:shadow",
            "peer-checked:before:left-[26px] peer-checked:bg-chestnut-rose peer-checked:border-chestnut-rose peer-checked:before:bg-white",
            className
          )}
        />
      </div>
    </>
  );
};

export default Switch;
